import { render, staticRenderFns } from "./Welfare.vue?vue&type=template&id=034a1877&"
import script from "./Welfare.vue?vue&type=script&lang=js&"
export * from "./Welfare.vue?vue&type=script&lang=js&"
import style0 from "./Welfare.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports